import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ErrorBoundary from '../../../ErrorBoundary';
import ConversionPoint from '../../../reusable-components/ConversionPoint/ConversionPoint';
import CustomizationButton from '../../../reusable-components/ProductCustomization/CustomizationButton';
import CustomizationSummary from '../../../reusable-components/ProductCustomization/CustomizationSummary';
import RatingSummary from '../../../reusable-components/Ratings/RatingSummary';
import displayUsp from '../../../utils/displayUsp';
import AddDeterminator from '../../components/addToCart/addDeterminator';
import Colorways from '../../components/colorways/colorways';
import Countdown from '../../components/countdown/countdown';
import GallerySlider from '../../components/gallerySlider/gallerySliderDesktop';
import Logo from '../../components/logo/logo';
import DiscountInfo from '../../components/marketinfo/discountinfo';
import SupplierInfo from '../../components/marketinfo/supplierInfo';
import MessageBox from '../../components/messageBox/MessageBox';
import OverlayFull from '../../components/overlayFull/overlayFull';
import Price from '../../components/price/price';
import ProductNumber from '../../components/productNumber/productNumber';
import Size from '../../components/sizes/size';
import SoldOut from '../../components/soldOut/soldOut';
// import BreadcrumbsNew from '../../components/breadcrumbs/BreadcrumbsNew';
import Title from '../../components/title/title';
import displayPriceMatch from '../../utils/displayPriceMatch';
import './aboveFoldStyle.less';

function AboveFold(props) {
  const {
    is_sold_out,
    has_sizeguide,
    cannot_buy_online,
    selections,
    suppliers,
    prices,
    isMobile,
    isExclusive,
    app
  } = props;

  const { messages } = window.__INITIAL_STATE__;

  const itemType = props.item_type;

  let hasFreeCustomization = props.free_customization;
  let hasCustomization = props.is_customizable;
  let isExternal = props.is_external;

  if (selections.sizeDetails) {
    hasFreeCustomization = selections.sizeDetails.free_customization;
    hasCustomization = selections.sizeDetails.is_customizable;
    isExternal = selections.sizeDetails.is_external;
  }

  const productID = window?.__INITIAL_STATE__?.product_id;

  const renderUiid = () => {
    /*
     * We need to ensure that Customization have actually been selected. Using app.customizationAdded
     *  is not enough, as it can sometimes be true without having any Customization.
     * This is why, we also check the customizationList.
     * */
    const hasSelectedCustomization =
      app.customizationAdded &&
      app.customization.customizationList &&
      Object.keys(app.customization.customizationList).length > 0;

    if (hasSelectedCustomization) {
      return (
        <div className="mx-[10px]">
          <ErrorBoundary location="Product Page" errorComponent={null}>
            <CustomizationSummary />
          </ErrorBoundary>
        </div>
      );
    }

    if (
      (!isExternal && hasCustomization) ||
      (isExternal && !hasCustomization) ||
      hasCustomization
    ) {
      return (
        <div className="mx-[10px]">
          <ErrorBoundary location="Product Page" errorComponent={null}>
            <CustomizationButton productID={productID} isPDP />
          </ErrorBoundary>
        </div>
      );
    }

    return null;
  };

  useEffect(() => {
    if (window?.config?.klarna_osm_enabled)
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }, [selections, prices]);

  return (
    <div id="aboveFold">
      <OverlayFull />
      {/* <div className="topComponent">
       <div className="topComponentInner">
       <Breadcrumbs hideTags/>
       <BreadcrumbsNew
       sidePadding breadcrumbs={window.__INITIAL_STATE__.breadcrumbs}
       position="top"
       /> : <Breadcrumbs />
       </div>
       </div> */}
      <div className="mainContentWrapper">
        <div className="aboveFoldLeft">
          <ErrorBoundary location="Product Page" errorComponent={null}>
            <GallerySlider />
          </ErrorBoundary>
        </div>
        <div className="aboveFoldRight">
          <div id="zoomedPic" />
          <div className="aboveTitle">
            <ProductNumber />
            <Logo />
          </div>
          <div className="bv-rating-container">
            <RatingSummary productID={productID} />
          </div>
          <Title />
          <ErrorBoundary location="Product Page" errorComponent={null}>
            <Price />
          </ErrorBoundary>
          <div className="spacer" />
          <Colorways productID={productID} />
          {is_sold_out ||
          cannot_buy_online ||
          (!prices.max_price && !prices.min_price) ? (
            <SoldOut />
          ) : (
            <div style={{ paddingTop: '10px' }}>
              {has_sizeguide && <Size type="guide" />}
              <Size type="list" />
              {props.is_customizable && renderUiid()}
              <AddDeterminator />
              {window?.config?.klarna_osm_enabled && (
                <div className="mx-[10px] my-4 min-h-[60px]">
                  <klarna-placement
                    data-key="credit-promotion-badge"
                    data-locale={
                      window?.config?.locale
                        ? window.config.locale.replaceAll('_', '-')
                        : 'en_GB'
                    }
                    data-purchase-amount={
                      selections?.sizeDetails?.prices?.price
                        ? parseFloat(selections.sizeDetails.prices.price)
                            .toFixed(2)
                            .toString()
                            .replaceAll('.', '')
                        : parseFloat(prices.min_price)
                            .toFixed(2)
                            .toString()
                            .replaceAll('.', '')
                    }
                  />
                </div>
              )}
              <MessageBox messages={messages} appData={app.data} />
              <Countdown />
              {props.isDiscountable === false && <DiscountInfo />}
              {selections.sizeDetails !== undefined ? (
                <ErrorBoundary location="Product page" errorComponent={null}>
                  <SupplierInfo {...selections.sizeDetails} />
                </ErrorBoundary>
              ) : (
                suppliers.length === 1 && (
                  <SupplierInfo supplier={suppliers[0]} isMobile={false} />
                )
              )}
              <div className="spacer" />
              {props.usps.map(usp => {
                if (
                  displayUsp(usp, {
                    hasCustomization,
                    displayPriceMatch: displayPriceMatch(prices, selections),
                    isPreorder: false,
                    isLimitedEdition: false,
                    hasFreeCustomization,
                    isExclusive,
                    itemType
                  })
                ) {
                  return (
                    <ConversionPoint
                      key={usp.icon}
                      headline={usp.headline}
                      link={usp.link}
                      icon={usp.icon}
                      body={usp.body}
                      type={usp.type}
                      isMobile={isMobile}
                    />
                  );
                }
                return null;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ app, general, usp }) => {
  return {
    app,
    is_sold_out: app.data.is_sold_out,
    cannot_buy_online: app.data.cannot_buy_online,
    has_sizeguide: app.data.has_sizeguide,
    free_customization: app.data.free_customization,
    selections: app.selections,
    suppliers: app.data.suppliers,
    sizes: app.data.sizes,
    prices: app.data.prices,
    supportLink: general.local_data.supportLink,
    pricematchLink: general.local_data.pricematchLink,
    is_customizable: app.data.is_customizable,
    isMobile: general.isMobile,
    usps: usp.general,
    isExclusive: app.data.is_exclusive,
    item_type: app.data.attributes.item_type,
    isDiscountable: app.data.is_discountable
  };
};

export default connect(mapStateToProps)(AboveFold);
